import React from "react";
import cx from "clsx";
export var Overlay = function (_a) {
    var isOpen = _a.isOpen;
    var visibilityClass = {
        "bg-opacity-25 h-full": isOpen,
        "bg-opacity-0 h-0 ": !isOpen,
    };
    return (React.createElement("div", { className: cx("md:hidden bg-gray-300 w-full fixed md:hidden z-20 left-0 top-0 delay-75 transition-colors duration-300", visibilityClass) }));
};
//# sourceMappingURL=Overlay.js.map